import PoolDevice from "./base";
import { StatesToDisplayItem, DisplayProcessingLogics, PoolDeviceCriticalDesiredActual } from "../Types";
import { IOnoffable, PoolDeviceInterface } from "../Interfaces";
import Locale from "../../utils/Locale";
import { DeviceTypes } from "../../config/documents/HardwareConfig";
import PoolDeviceOnOffable from "./base-onoffable";

export enum criticalFieldIdentifiers {
    OnOff = "OnOff"
}

export default class PoolDeviceAutoFill extends PoolDeviceOnOffable implements PoolDeviceInterface, IOnoffable {
    static DeviceType = DeviceTypes.AUTOFILL;
    static Icon = "autofill";
    static PickerTitle = Locale.gettext("Autofill");

    OnOffIdentifier = criticalFieldIdentifiers.OnOff;
    
    
    getDisplayNameTranslated(displayName:string) {
        switch (displayName) {
        case "Water Level Sensor": return Locale.gettext("Water Level Sensor");
        case "Sensor": return Locale.gettext("Sensor");
        default: return super.getDisplayNameTranslated(displayName);
        }
    }

    getInformationFields(): StatesToDisplayItem[] {
        let order = 0;
        const fields = [];
        fields.push({
            Name: PoolsideDaemonDeviceStateNames.FloatSwitchState,
            DisplayName: "Water Level Sensor",
            DisplayNameShort: "Sensor",
            DisplayOrder: ++order,
            DisplayProcessingLogic: DisplayProcessingLogics.ONOFF,
            DisplayProcessingLogicUnitAsDisplayName: true,
        });
        return fields;
    }
    
    getCriticalFields(): PoolDeviceCriticalDesiredActual[] {
        let order = 0;
        const fields = [];
    
        {
            const DisplayName = Locale.gettext("Power");
            const common = {
                DisplayName, DisplayNameShort: DisplayName,
                DisplayOrder: ++order,
                DisplayProcessingLogic: DisplayProcessingLogics.ONOFF,
                DisplayProcessingLogicUnitAsDisplayName: false,
            };
            fields.push({
                Identifier: criticalFieldIdentifiers.OnOff,
                ActualProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.ActualPowerState }, common),
                DesiredProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.PowerState }, common)
            });
        }
    
        return fields;
    }
}

export enum PoolsideDaemonDeviceStateNames {
    ActualPowerState = "ActualPowerState",
    FloatSwitchState = "FloatSwitchState",
    PowerState = "PowerState",
}

